import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getListData } from "../../../commonFunctions/CommonFunctions";
import { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { Header } from "../../../Components/Header/Header";
import { useForm } from "react-hook-form";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { ChequeIssuedList } from "./CheckIssuedList";
import { ChequeNotIssuedList } from "./CheckNotIssuedList";

export const ActionCheckIssuedOrNo: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const {
    control,
    reset,
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<any>();
  const { showMessage } = useSnackbar();
  const [reconcileData, setReconcielData] = useState([]);
  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };
  useEffect(() => {
    const body = {
      page: 1,
      pageSize: 1000000,
      filter: [
        {
          field: "ChequeIssued",
          operator: "eq",
          value: "false"
        },
        {
          field: "Reconciling",
          operator: "eq",
          value: "false"
        }
      ],
      sort: []
    };
    async function getRecon() {
      const response: any = await getListData("Bill/search", body);
      setReconcielData(response || []);
    }
    getRecon();
  }, []);

  const tabsData: any[] = [
    { label: "Cheque Not Issued", content: <ChequeNotIssuedList /> },
    { label: "Cheque Issued", content: <ChequeIssuedList /> },

  ];

  const columns: IColumns[] = [
    {
      header: "Supplier Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      type: "default"
    },
    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },
    {
      header: "Due Date",
      fieldName: "dueDate",
      type: "date"
    },

    {
      header: "Category",
      fieldName: "category",
      type: "default"
    }
  ];

  const transFormData = (data: any) => {
    data &&
      data?.map((item: any) => {
        item.name = item?.supplier?.name;
      });
    return data;
  };

  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Header
        type="simple"
        isDivider={true}
        title={`ChequeIssued Or Not`}
        id={"ActionReconcilationOrCheque"}
        headerSx={{ marginTop: 0 }}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTabs
            id="adasd"
            control={control}
            name="tabs"
            tabs={tabsData}
            justifyTabs="flex-start"
          />
        </Grid>
      </Grid>
    </>
  );
});
